import _ from 'lodash';

import { MaybeUndef } from '../../types/system';

import { ListState } from './list.reducer';
import { PossibleIdentityKeysOf } from './list.types';

export const updateItemByKey = <T extends object>(
  state: ListState<T>,
  updater: (item: T) => T,
  keyValue: string,
): ListState<T> => {
  const item: MaybeUndef<T> = state.itemsMap[keyValue];
  if (item === undefined) {
    return state;
  }

  return {
    ...state,
    itemsMap: {
      ...state.itemsMap,
      [keyValue]: updater(item),
    },
  };
};

export const appendNewItem = <T extends object>(
  state: ListState<T>,
  newItem: T,
  keyFieldName: PossibleIdentityKeysOf<T>,
): ListState<T> => {
  const keyValue: string = newItem[keyFieldName].toString();

  return {
    ...state,
    itemsMap: {
      ...state.itemsMap,
      [keyValue]: newItem,
    },
    idsOrdered: [...state.idsOrdered, keyValue],
  };
};

export const appendNewItems = <T extends object>(
  state: ListState<T>,
  newItems: T[],
  keyFieldName: PossibleIdentityKeysOf<T>,
): ListState<T> => {
  const items = _.mapKeys(newItems, (item: T) => item[keyFieldName]);

  const orderedItems = _.sortBy(
    {
      ...items,
      ...state.itemsMap,
    },
    keyFieldName,
  );

  const idsOrdered = _.map(orderedItems, (item: T): string =>
    _.toString(item[keyFieldName]),
  );

  const itemsMap = _.mapKeys(orderedItems, keyFieldName);

  return {
    ...state,
    itemsMap,
    idsOrdered,
  };
};

export const removeItem = <T extends object>(
  state: ListState<T>,
  keyValue: string,
): ListState<T> => {
  return {
    ...state,
    itemsMap: {
      ..._.omit(state.itemsMap, keyValue),
    },
    idsOrdered: _.without(state.idsOrdered, keyValue),
  };
};
